import Broadcast from "../broadcast";
import ForumComment from "@/models/ForumComment";

export class ForumCommentCreated extends Broadcast<ForumComment> { }
export class ForumCommentEdited extends Broadcast<ForumComment> { }
export class ForumCommentUpdated extends Broadcast<ForumComment> { }